(function dbaDefinition() {
    'use strict';
    angular.module('Entities')
        .service('dbaService', [
            'restUrlBuilder', 'authExtend', function dbaService(restUrlBuilder) {
                restUrlBuilder = restUrlBuilder('edr');

                this.get = function get(key, id) {

                    if (key == null || id == null) {
                        throw 'Los parametros no pueden ser null';
                    }
                    var params = {
                        objectId: id,
                        objectTypeKey: key
                    };
                    
                    return restUrlBuilder.all('AdminMongoIndexes')
                        .get({ params: params });
                };

                this.modify = function modify(key, id, index) {
                    if (key == null || id == null || index == null) {
                        throw 'Los parametros no pueden ser null';
                    }
                    var parameters = {
                        ObjectId: id,
                        ObjectTypeKey: key,
                        JsonIndex: index
                    };

                    return restUrlBuilder.all('AdminMongoIndexes')
                        .put(parameters);
                };

                this.delete = function del(key, id, index) {
                    if (key == null || id == null || index == null) {
                        throw 'Los parametros no pueden ser null';
                    }
                    var params = {
                        ObjectId: id,
                        ObjectTypeKey: key,
                        JsonIndex: index
                    };

                    return restUrlBuilder.all('AdminMongoIndexes')
                        .delete({ params: params  });
                };
            }
        ]);
})();